import { get, post, del, put } from '@elementary/common-ui/utils/http';
import {
  CreateGroupRequest,
  Group,
  SetGroupRolesRequest,
  SetGroupUsersRequest,
  UpdateGroupRequest,
} from './types';

export const fetchGroups = (): Promise<Group[]> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/account/groups`);

export const createGroup = (data: CreateGroupRequest): Promise<Group> =>
  post(`${import.meta.env.VITE_API_BASE_URL}/account/groups`, data);

export const updateGroup = (
  groupId: string,
  data: UpdateGroupRequest,
): Promise<Group> =>
  put(`${import.meta.env.VITE_API_BASE_URL}/account/groups/${groupId}`, data);

export const setGroupRoles = (
  groupId: string,
  data: SetGroupRolesRequest,
): Promise<void> =>
  put(
    `${import.meta.env.VITE_API_BASE_URL}/account/groups/${groupId}/roles`,
    data,
  );

export const setGroupUsers = (
  groupId: string,
  data: SetGroupUsersRequest,
): Promise<void> =>
  put(
    `${import.meta.env.VITE_API_BASE_URL}/account/groups/${groupId}/users`,
    data,
  );

export const deleteGroup = (groupId: string): Promise<void> =>
  del(`${import.meta.env.VITE_API_BASE_URL}/account/groups/${groupId}`);
